import { render, staticRenderFns } from "./photodelivery.vue?vue&type=template&id=7ab99ae8"
import script from "./photodelivery.vue?vue&type=script&lang=js"
export * from "./photodelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports